import { render, staticRenderFns } from "./RequestDeclineApproveTableCell.vue?vue&type=template&id=6656c790&scoped=true"
import script from "./RequestDeclineApproveTableCell.vue?vue&type=script&lang=js"
export * from "./RequestDeclineApproveTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6656c790",
  null
  
)

export default component.exports